<template>
  <!-- The files on a message: pictures as thumbnails, everything else as a
       file card. Each opens in a new tab. -->
  <div class="ta-list" :class="{ 'ta-list--end': align === 'end' }">
    <div v-if="images.length" class="ta-images">
      <a
        v-for="(file, index) in images"
        :key="keyOf(file, index)"
        class="ta-image"
        :href="attachmentUrl(file)"
        target="_blank"
        rel="noopener"
        :title="file.name"
      >
        <img :src="attachmentUrl(file)" :alt="file.name || 'Attachment'" loading="lazy" @error="markBroken(file)" />
      </a>
    </div>
    <ul v-if="files.length" class="ta-files">
      <li v-for="(file, index) in files" :key="keyOf(file, index)" class="ta-file">
        <a class="ta-file__link" :href="attachmentUrl(file)" target="_blank" rel="noopener" :title="file.name">
          <span class="ta-file__icon"><i class="pi" :class="attachmentIcon(file)" aria-hidden="true"></i></span>
          <span class="ta-file__meta">
            <span class="ta-file__name">{{ file.name || 'Attachment' }}</span>
            <span v-if="formatFileSize(file.size)" class="ta-file__size">{{ formatFileSize(file.size) }}</span>
          </span>
          <i class="pi pi-download ta-file__dl" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { attachmentIcon, attachmentUrl, formatFileSize, isImageAttachment } from '@/utils/ticket';

export default {
  name: 'TicketAttachmentList',
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    // Which edge the files line up on: the side of the message they belong to.
    align: {
      type: String,
      default: 'start',
    },
  },
  data() {
    return {
      // Images the browser could not draw, shown as files instead.
      broken: {},
    };
  },
  computed: {
    images() {
      return this.attachments.filter((file) => this.isPicture(file));
    },
    files() {
      return this.attachments.filter((file) => !this.isPicture(file));
    },
  },
  methods: {
    attachmentIcon,
    attachmentUrl,
    formatFileSize,
    keyOf(file, index) {
      return file.key || file.url || `${file.name}-${index}`;
    },
    isPicture(file) {
      return isImageAttachment(file) && !this.broken[attachmentUrl(file)];
    },
    markBroken(file) {
      this.broken = { ...this.broken, [attachmentUrl(file)]: true };
    },
  },
};
</script>
